module.exports = __webpack_public_path__ + "static/media/play.1cc909e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/play.svg
// module id = 21
// module chunks = 0